/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type AccountHolderType =
  typeof AccountHolderType[keyof typeof AccountHolderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountHolderType = {
  JOINT: 'JOINT',
  INDIVIDUAL: 'INDIVIDUAL',
  COMPANY: 'COMPANY',
  TRUST: 'TRUST',
  CHARITY: 'CHARITY',
} as const;
